import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();
  const homeHref = location.pathname === '/' ? '#home' : '/';

  return (
    <footer className="bg-[#1c1c1c] py-10 border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row gap-6 items-center justify-between">
        <a href={homeHref} className="font-display text-yellow text-xl tracking-tight">
          LLIT-Media<span className="text-white">.de</span>
        </a>

        <div className="flex items-center gap-6">
          <Link
            to="/impressum"
            className="text-zinc-400 hover:text-yellow transition-colors text-sm"
          >
            Impressum
          </Link>
          <Link
            to="/datenschutz"
            className="text-zinc-400 hover:text-yellow transition-colors text-sm"
          >
            Datenschutzerklärung
          </Link>
        </div>

        <p className="text-zinc-500 text-sm">
          © {new Date().getFullYear()} LLIT-Media — Bremen. Alle Rechte vorbehalten.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
